import * as Logger from "js-logger";
export function EnableOnScreenErrors() {

    window.onerror = (message, url, lineNumber, colNumber, error) => {

        const errorBox = document.createElement("div");
        const errorMessage = document.createElement("div");

        errorBox.style.display = "table";
        errorBox.style.width = "100%";
        errorBox.style.height = "100%";
        errorBox.style.position = "fixed";
        errorBox.style.top = "0";
        errorBox.style.left = "0";
        errorBox.style.zIndex = "1000";

        errorBox.style.color = "white";
        errorBox.style.fontFamily = "Consolas, monaco, monospace";
        errorBox.style.fontSize = "2vw";

        errorMessage.style.backgroundColor = "black";
        errorMessage.style.backgroundClip = "content-box";

        errorMessage.style.textAlign = "center";

        errorMessage.innerHTML = message + "<br />";
        errorMessage.innerHTML += "Error in " + url + " :: " + "Line " + lineNumber + ", Col " + colNumber + "<br /><br />";
        errorMessage.innerHTML += error.stack;

        Logger.error(error.stack);

        errorBox.appendChild(errorMessage);
        document.body.appendChild(errorBox);
    };
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/utils/debug.ts